import { render, staticRenderFns } from "./sendConference.vue?vue&type=template&id=44237556"
import script from "./sendConference.vue?vue&type=script&lang=js"
export * from "./sendConference.vue?vue&type=script&lang=js"
import style0 from "./sendConference.vue?vue&type=style&index=0&id=44237556&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports